import { useAccountType } from '@/hooks/useAccountType'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useSubscriptionFeatures } from '@/hooks/useSubscriptionFeatures'

import type { MeetingRecorderAvailabilityResult } from '@scrambl/shared'
import {
  FEATURE_KEYS,
  resolveMeetingRecorderAvailability,
} from '@scrambl/shared'

/**
 * Which recorder UI to render: nothing (personal / flag off / still
 * resolving), a neutral locked state (plan lacks `meeting_recorder`), or the
 * recorder. Render-time only — every START also runs preflightRecordingStart
 * against the server, which is authoritative.
 */
export function useMeetingRecorderAvailability(): MeetingRecorderAvailabilityResult & {
  isLoading: boolean
} {
  const { isPersonal } = useAccountType()
  const { checkFeatureFlag, isLoading: isFlagsLoading } = useFeatureFlags()
  const { checkFeature, isLoading: isFeaturesLoading } =
    useSubscriptionFeatures()

  const isFlagEnabled = checkFeatureFlag('MEETING_NOTES')
  const isLoading =
    !isPersonal && (isFlagsLoading || (isFlagEnabled && isFeaturesLoading))
  if (isLoading) {
    // Don't flash a lock (or the recorder) before the plan is known
    return { availability: 'hidden', reason: null, isLoading }
  }

  return {
    ...resolveMeetingRecorderAvailability({
      isPersonal,
      isFlagEnabled,
      isEntitled: checkFeature(FEATURE_KEYS.MEETING_RECORDER),
    }),
    isLoading,
  }
}
